<template>
  <b-row class="p-4">
    <b-col cols="12" class="mb-4">
      <b-skeleton-img no-aspect height="280px"></b-skeleton-img>
    </b-col>
    <b-col cols="3" class="mt-3">
      <b-card>
        <div class="d-flex">
          <b-skeleton type="avatar"></b-skeleton>
          <b-skeleton class="skeleton-name" animation="wave"></b-skeleton>
        </div>
        <b-skeleton class="mt-3" animation="wave"></b-skeleton>
        <b-skeleton animation="wave" width="50%"></b-skeleton>
        <b-skeleton class="mt-3" width="50px" animation="wave"></b-skeleton>
        <b-skeleton animation="wave"></b-skeleton>
        <b-skeleton class="mt-3" width="50px" animation="wave"></b-skeleton>
        <b-skeleton animation="wave"></b-skeleton>
        <div class="mt-2 d-flex">
          <b-skeleton type="avatar" size="1.5rem"></b-skeleton>
          <b-skeleton class="ml-2" type="avatar" size="1.5rem"></b-skeleton>
          <b-skeleton class="ml-2" type="avatar" size="1.5rem"></b-skeleton>
          <b-skeleton class="ml-2" type="avatar" size="1.5rem"></b-skeleton>
        </div>
      </b-card>
      <b-skeleton class="mt-2" type="input" height="90px"></b-skeleton>
      <b-skeleton class="mt-2" animation="wave" width="120px"></b-skeleton>
      <b-skeleton class="mt-2 skeleton-btn" type="button"></b-skeleton>
    </b-col>
    <b-col cols="9" class="mt-3">
      <b-card>
        <b-skeleton class="mt-1" animation="wave" width="50px"></b-skeleton>
        <b-skeleton
            class="skeleton-input mt-2"
            type="input"
            height="70px"
        ></b-skeleton>
        <b-skeleton
            class="mt-4"
            width="120px"
            animation="wave"
        ></b-skeleton>
        <div class="mt-2 d-flex">
          <b-skeleton type="avatar" size="2rem"></b-skeleton>
          <b-skeleton class="ml-2" type="avatar" size="2rem"></b-skeleton>
          <b-skeleton class="ml-2" type="avatar" size="2rem"></b-skeleton>
          <b-skeleton class="ml-2" type="avatar" size="2rem"></b-skeleton>
        </div>
        <div class="dash-border"></div>
        <div class="d-flex mt-3">
          <b-skeleton class="skeleton-toggle" type="button"></b-skeleton>
          <div class="ml-2">
            <b-skeleton
                class="mt-2"
                width="250px"
                animation="wave"
            ></b-skeleton>
            <b-skeleton
                class="mt-2"
                width="250px"
                animation="wave"
            ></b-skeleton>
          </div>
        </div>
        <div class="d-flex mt-3">
          <b-skeleton class="skeleton-toggle" type="button"></b-skeleton>
          <div class="ml-2">
            <b-skeleton
                class="mt-2"
                width="250px"
                animation="wave"
            ></b-skeleton>
            <b-skeleton
                class="mt-2"
                width="250px"
                animation="wave"
            ></b-skeleton>
          </div>
        </div>
        <div class="foot">
          <b-skeleton
              class="mt-2 skeleton-save-btn"
              type="button"
          ></b-skeleton>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "HeartBeat_Skeleton",
};
</script>

<style lang="scss" scoped>
.guide-management {
  padding: 24px;
  height: 100%;
  .profile-card {
    border-radius: 8px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    padding: 16px;
    .personel {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .avatar {
        height: 48px;
        width: 48px;
        border-radius: 50%;
        object-fit: cover;
      }
      .profile-name {
        margin-left: 10px;
        h3 {
          font-weight: 600;
          font-size: 16px;
          line-height: 22px;
          color: #474d52;
          margin-bottom: 0;
        }
      }
    }
    .desc {
      margin-top: 15px;
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;

        /* Body */

        color: #474d52;
      }
    }
    .foot {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      & > div {
        margin-right: 12px;
        cursor: pointer;
      }
    }
  }
  .published {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #474d52;
    display: block;
    margin-top: 15px;
    @media (max-width: 991px) {
      margin-top: 34px !important;
      margin-bottom: 40px;
    }
  }
  .btn-round-fill {
    margin: 18px 0px;
  }
}
.heading__ {
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.05em;
  color: #8d99a0;
  text-transform: uppercase;
  margin-bottom: 0;
  margin-top: 10px;
}
.link__ {
  display: grid;
  grid-template-columns: 1fr 30px;
  align-items: center;
  .link {
    overflow-wrap: anywhere;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #557efb;
  }
  .ico {
    cursor: pointer;
    justify-self: flex-end;
  }
}
.skeleton-name {
  width: 80px;
  margin-top: 11px;
  margin-left: 11px;
}
.skeleton-btn {
  border-radius: 20px;
}
.skeleton-input {
  border-radius: 16px;
}
.dash-border {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23ddddddff' stroke-width='1' stroke-dasharray='3%2c 6' stroke-dashoffset='0' stroke-linecap='butt'/%3e%3c/svg%3e");
  height: 1px;
  margin-bottom: 10px;
  margin-top: 20px;
}
.skeleton-toggle {
  height: 30px;
  width: 70px;
  margin-top: 13px;
}
.foot {
  margin-top: 15px;
  border-top: 1px solid #dddddd;
  padding-top: 10px;
}
.skeleton-save-btn {
  border-radius: 20px;
  width: 120px;
}
.upload {
  margin-bottom: 1rem;
  .upload-video {
    margin-top: 15px;
    font-family: Nunito;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    color: #8d99a0;
  }
  .upload-btn {
    margin-top: 16px;
    width: 208px;
    height: 40px;
    border-radius: 100px;
    border: none;
    outline: none !important;
    .ico {
      margin-right: 5px;
    }
    .btn-content {
      margin-top: 5px;
      font-family: Nunito;
      font-style: normal;
      font-weight: 800;
      font-size: 16px;
      line-height: 22px;
      color: #557efb;
    }
  }
  .video {
    color: #fff !important;
    background-color: #557efb !important;
  }
  .no-video {
    color: #557efb;
    background: rgba(85, 126, 251, 0.1);
  }
  .watch-video {
    margin-top: 5px;
    font-family: Nunito;
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
  }
}
</style>